<template>
    <div style="">
        <transition name="blur">
            <div v-if="isOpen" class="backdrop"></div>
        </transition>

        <transition name="bottom">
            <div v-if="isOpen" class="menu_option_wrap" >
                <div ref="scrollRef" style="height:640px; max-width:366px; width:90%; background-color: white; border-radius:24px; display:flex; flex-direction: column;">
                    <div style="color:#210F03; font-size:16px; font-weight:bold; display:grid; place-items: center; height:51px;">사커하우 코치 이용 약관</div>
                    <div @scroll="scroll($event)" style="flex:1; overflow:auto; white-space: pre-wrap; color:#210F03; font-size:14px; font-weight:500;line-height: 24px; padding:12px;" v-html="text"></div>
                    <div style="padding:20px 12px;">
                        <div class="btn" :class="[is_end ? 'active' : '']" @click="agree">동의합니다.</div>
                    </div>
                </div>
            </div>
        </transition>
        <div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "TempCoachAgreement",
        props : {
            isOpen : {
                type : Boolean,
                default : false,
            },
            closeAction : {
                type : Function,
                default : () => {}
            }
        },
        methods : {
            agree(){
                if(!this.is_end) return;
                localStorage.setItem('HIDE_COACH_AGREEMENT', '1');
                this.closeAction();
            },
            scroll(e){
                const currentTarget = e.currentTarget;
                if((currentTarget.offsetHeight + currentTarget.scrollTop + 50) >= currentTarget.scrollHeight){
                    this.is_end = true;
                } else {
                    this.is_end = false;
                }
            }
        },
        data(){
            return {
                is_end : false,
                text : `주식회사 사커하우 이용 약관 (코치, 지점용)

제 1 장 총칙
제 1 조 (목 적)
이 약관은 이용자가 사커하우(이하“회사”)가 운영하는 인터넷 서비스 사이트(이하 “사이트” 또는 “사커하우”)를 통해 제공하는 인터넷 전자상거래 관련 서비스(이하 “서비스”)와 관련하여 회사와 코치의 권리, 의무, 책임사항을 규정함을 목적으로 합니다.  또한 본 약관은 유무선 PC통신, 태블릿 PC, 스마트폰(아이폰, 안드로이드폰 등) 어플리케이션 및 모바일웹 등을 이용하는 전자상거래 등에 대해서도 그 성질에 반하지 않는 한 준용됩니다.
본 약관이 규정한 내용 이외의 회사와 이용자 간의 권리, 의무 및 책임사항에 관하여서는 전기통신사업법 기타 대한민국의 관련 법령과 상관습에 의합니다.
제 2 조 (정 의)
이 약관에서 사용하는 용어의 정의는 다음과 같습니다.
1. 회사가 운영하는 사이트는 아래와 같습니다.
 스마트폰 및 이동통신기기를 통해 제공되는 &사커하우&모바일 어플리케이션,
 그리고 추후 회사에서 공지하고 제공하는 기타 웹사이트 등입니다.
2.  코치: 사커하우앱에 코치로 접속하여 이 약관에 따라 서비스를 받는 회원을 말합니다. 회사에 개인정보를 제공하여 회원등록을 한 자로서,  회사와      서비스 이용계약을 체결하고 회원 아이디(ID)를 부여 받아 회원에게 견적을 보내거나 전문적인 지식에 답변을 하는 등 고객을 찾기 위한 서비스를  계속적으로 이용할 수 있는 자를 말합니다.
3. 회원: 본 약관에 따라 회사와 서비스 이용계약을 체결하고 회원 아이디(ID)를 부여받아 회사가 제공하는 서비스를 이용하는 개인을 말합니다.  사이트 내에 게시된 광고를 열람하거나 요청서를 작성하고 코치에게 레슨 신청서를 보내거나 질문을 하는 등 사이트를 계속적으로 이용할 수 있는 자를 말합니다.
4. 지점 :사커하우 앱과 웹사이트를 회사로부터 부여받아 운영중인 축구교실이나 축구장 등을 등록할 수 있으며,  운영중인 축구교실의 회원들의 정보를 등록할 수 있고, 회원들에게 공지를 할 수 있으며, 축구교실 레슨비를 앱에서 결제할수 있는 등 사이트를 지속적으로 이용할 수 있는 회사를 말한다.
5. 용병: 축구의 전반적인 구력과 실력에 대한 구체적인 정보를 입력하고, 이를 통해 축구레슨이나 축구 경기에 참여할 수 있는 제도이다. 용병의 몸값은 0원부터 개인이 설정할 수 있으며, 경기나 레슨후 함께 운동한 참여자들로부터 경기력에 대한 평가를 받을 수 있다.
6. 멤버 : 앱내 회원들끼리 축구와 관련한 목적을 가지고 만들 수 있는 채팅방이다.
7. 콘텐츠(Contents): 회사가 사커하우에서 제공하는 정보, 요청서 작성, 견적 작성, 요청서 수신, 견적 수신, 프로그램 등 부호ㆍ문자ㆍ도형ㆍ색채ㆍ음성ㆍ음향ㆍ이미지ㆍ영상 및 복합체의 정보나 자료를 의미합니다.
8.회원 아이디(이하 “ID”): 회원의 식별과 회원의 서비스 이용을 위하여 회원이 선정하고 회사가 승인하는 문자 또는 숫자의 조합을 말합니다.
9. 비밀번호(Password): 이용자가 등록회원과 동일인인지 신원을 확인하고, 회원의 통신상 개인정보를 보호하기 위하여 회원이 정한 문자와 숫자의 조합을 말합니다.
10. 회원 탈퇴: 회원이 이용계약을 종료시키는 행위를 말합니다.
11. 멤버톡 : 회원간의 채팅 등 사커하우에서 제공하는 방식을 통해 상호작용 할 수 있는 행위를 의미 합니다.
12. 게시물 : 회원이 사커하우 상에 게시 또는 등록하는 부호(URL 포함), 문자, 이미지, 사진, 동영상, 음성, 파일 등을 말합니다.
13 나우 : 회원이 코치를 검색하여 레슨권 구매 및 코치님 예약을 통해 코치와 수업을 진행할 수 있습니다.
제 3 조 (약관의 명시, 효력 및 개정)
1. 회사는 이 약관의 내용과 주소지, 관리자의 성명, 개인정보보호 담당자의 성명, 연락처(전화, 팩스, 전자우편 주소 등) 등을 이용자가 알 수 있도록 사커하우의 초기 서비스 화면에 게시합니다. 다만, 약관의 구체적 내용은 이용자가 연결화면을 통하여 볼 수 있습니다.
2. 이 약관은 그 내용을 사커하우에 게시하거나 이메일 등 기타의 방법으로 회원에게 공지함으로써 효력이 발생합니다.
3. 서비스 이용 시 화면에서 제시되는 경고 메시지의 효력은 본 약관의 효력과 동일합니다.
4. 회사는 약관의 규제에 관한 법률, 전자문서 및 전자거래기본법, 전자서명법, 정보통신망 이용촉진 및 정보 보호 등에 관한 법률 기타 관련 법령을 위배하지 않는 범위 내에서 약관을 변경할 수 있습니다.
5. 회사는 약관이 변경되는 경우에는 적용일자 및 변경사유를 명시하여 현행약관과 함께 사커하우의 초기 서비스 화면 또는 팝업화면으로 적용일자의 7일 이전부터 적용일 후 상당한 기간 동안 게시합니다. 다만, 회원의 권리, 의무에 중대한 영향을 미칠 수 있는 변경 및 개정의 경우에는 적용일자 30일 전부터 이메일을 통하여 개별 공지하도록 합니다.
6. 회원은 개정되는 약관의 전체 또는 일부 내용에 동의하지 않을 수 있습니다. 회원이 본 약관의 변경에 대하여 동의하지 않는 경우 회원탈퇴를 통해 이용계약을 해지할 수 있습니다.
7. 회사가 약관 변경의 공지를 통해 개정된 약관의 적용일자로부터 7일(회원에게 불리하거나 중대한 사항의 변경인 경우에는 30일)내에 이용자가 동의하지 않는다는 의사를 표시하지 아니하면 약관에 동의한 것으로 본다는 내용을 명확하게 함께 고지하였음에도, 회원이 동의하지 않는다는 의사를 표시하지 않는 경우 회사는 회원이 적용 시행일자로부터 약관의 변경에 동의한 것으로 간주합니다.
제 4 조 (약관 외 준칙)
1. 이 약관은 회사가 제공하는 개별서비스에 관한 이용안내(이하 “서비스 개별 안내”)와 함께 적용합니다.
2. 이 약관의 내용이 서비스 별 안내와 상충되는 경우에는 이 약관이 우선하여 적용됩니다.
3. 이 약관에 명시되지 않은 사항에 대해서는 전기통신사업법, 전자문서 및 전자거래기본법, 정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하“정보통신망법”), 저작권법, 개인정보보호법, 학원의 설립 ㆍ운영 및 과외교습에 관한 법률법, 기타 관련법령 및 서비스 별 안내의 규정에 의합니다.


제 2 장 서비스 이용 계약
제 5 조 (이용 계약의 성립)
1. 이용 계약은 서비스 이용 희망자의 이 약관에 대해 동의한다는 의사표시와 이용 신청에 대한 회사의 승낙으로 성립됩니다.
2. 이 약관에 대한 동의는 이용 신청 당시 서비스 이용 희망자의 이용약관의 확인과 명시적 의사표시를 통해 성립됩니다.
3. 이용 계약은 만 4세 이상의 개인 또는 기업(개인사업자 및 법인사업자 등)이 할 수 있습니다. 타인의 정보를 도용하여 회원으로 가입한 자는 회사가 제공하는 서비스를 이용할 수 없으며, 이용하여서도 안 됩니다.
제 6 조 (회원가입 및 승낙)
1. 회원가입은 회원이 되고자 하는 이용자(이하 “가입신청자”)가 약관의 내용에 동의를 하고, 회사가 정한 가입 양식에 따라 회원정보(이용자ID), 비밀번호, 주소, 연락처 등)를 기입하여 회원가입신청을 하고 회사가 이러한 신청에 대하여 승인함으로써 체결됩니다.
2. 이용자의 회원가입신청에 대하여 회사가 승낙한 경우, 회사는 회원 ID/Password와 기타 회사가 필요하다고 인정하는 내용을 이용자에게 통지합니다.
3. 회사는 이용자의 신청에 대해서 회원가입을 승낙하는 것을 원칙으로 합니다. 다만, 다음 각 호에 해당하는 신청에 대하여는 승인을 하지 아니할 수 있습니다.
   1. 본인 실명이 아니거나 다른 사람의 명의를 사용하여 신청하였을 때
   2. 서비스 이용 계약 신청서의 내용을 허위로 기재하였을 때
   3. 사회의 안녕과 질서 혹은 미풍양속을 저해할 목적으로 신청하였을 때
   4. 부정한 용도로 본 서비스를 이용하고자 하는 경우
   5. 영리를 추구할 목적으로 본 서비스를 이용하고자 하는 경우
   6. 본 서비스와 경쟁관계에 있는 이용자가 신청하는 경우
   7. 기타 이용신청자의 귀책사유로 이용승낙이 곤란한 경우
   8. 같은 사용자가 다른 계정으로 이중 등록을 한 경우
   9. 사커하우에서 이용약관 또는 법률 위반 등의 사유로 이전에 회원자격이 상실 또는 이용계약이 해지되었던 경우
  10. 회사로부터 회원자격정지 조치를 받은 회원이 이용정지 중에 이용계약을 임의 해지하고 재이용 신청을 하는 경우
4. 회사는 서비스 이용신청이 다음 각 호에 해당하는 경우에는 그 신청에 대하여 승낙, 제한사유가 해소될 때까지 승낙을 유보할 수 있습니다
   1. 회사가 설비의 여유가 없는 경우
   2. 회사의 기술상 지장이 있는 경우
   3. 기타 회사의 귀책사유로 이용승낙이 곤란한 경우
제 7 조 (서비스 이용)
1. 회원은 사이트를 통한 회원가입 시 발급된 ID 하나로 제1장 제2조 1항에 명시된 모든 사이트에 자동 가입되며, 해당 서비스를 이용할 수 있습니다. 단, 일부 사이트의 특정 서비스는 별도의 가입절차를 통하여 이용할 수 있으며, 이 경우 해당 사이트의 이용 시에는 해당 사이트의 특정서비스에 대한 이용약관이 이 약관보다 우선 적용됩니다.
2. 회원의 최초 서비스 이용신청 이후 사이트가 늘어난 경우에도 신규 사이트의 이용약관에서 달리 명시되지 않는 한 제1항의 내용이 마찬가지로 적용됩니다. 이 경우 회사는 신규 사이트의 서비스 개시 일자, 회원자동가입 사실 기타 관련 정보를 그 개시일 7일 이전부터 개시 일까지 각 사이트에 공지하거나, 또는 그 개시일 30일 이전까지 이메일 통지 등으로 각 회원에게 개별 통지합니다. 회원은 신규 사이트에 자동가입되는 것을 원하지 않을 경우 거부할 수 있습니다.
3. 사커하우 서비스 이용은 사이트의 업무상 또는 기술상 특별한 지장이 없는 한 연중무휴, 1일 24시간을 원칙으로 합니다.
4. 회사가 사커하우에서 제공하는 서비스는 기본적으로 무료입니다. 단, 별도로 회원이 코치에게 레슨권 구매 및 예약을 통해 코치와 채팅방을 개설하거나 코치가 회원에게 견적을 보내는 등 일부 특정 서비스를 이용하기 위해서는 코치는 회사로부터 구해당 서비스를 이용을 위해 결제금액의 일부를 사커하우에 지불하여야 합니다.
4. 유료서비스 이용 요금 및 결제 방식은 해당 서비스에 명시되어 있는 규정에 따릅니다.
5. 회사는 통신판매중개업자로서 서비스 요금이 무료인 서비스와 일부 유료서비스 이용과 관련하여 이용자들 사이에서 발생한 거래와 관련된 손해에 대해서는 회사에 고의 또는 과실이 있는 경우를 제외하고는 책임을 지지 않습니다.


제 3 장 서비스 제공 및 변경
제 8 조 (서비스 내용)
회사가 제공하는 서비스의 내용은 다음과 같습니다.
1. 고객에게 코치의 경력 및 정보 제공
2. 코치에게 근처 고객의 정보제공
3. 근처 운동장 정보 제공
4. 고객에게 근처 고객 및 코치 정보 제공하여 함께 레슨 및 운동 가능
5. 고객에게 용병 정보 제공
6. 사커하우앱내 축구관련 질문과 답변의 질관리
7. 기타 관련 부수적 서비스
제 9 조 (정보의 제공 및 광고의 게재)
1. 회사는 회원에게 서비스 이용에 필요하다고 인정되는 각종 정보 및 광고에 대해서 사이트 및 이메일, SMS, DM 발송 등 각종 매체에 게재하는 방법 등으로 회원에게 제공할 수 있습니다. 단, 광고성 정보 전송의 경우에는 사전에 회원이 명시적으로 광고수신에 동의한 경우에만 전송하며 회원은 회사가 제공하는 방법에 따라 광고 수신을 거부할 수 있습니다.
2. 회사는 서비스 개선 및 소개 등을 목적으로 회원의 동의 하에 추가적인 개인정보를 요청할 수 있습니다.
3. 회사는 서비스의 운용과 관련하여 사이트, 이메일, SMS, DM 등에 광고 등을 게재할 수 있습니다.
제 10 조 (서비스 제공의 제한 및 중단)
1. 회사는 정기점검, 보수, 교체 등 회사가 필요한 경우 및 부득이한 사유로 인하여 서비스 이용에 지장이 있는 경우에는 서비스의 이용의 전부 또는 일부를 제한하거나 일시 중단할 수 있습니다.
2. 전시, 사변, 천재지변 또는 이에 준하는 국가 비상사태가 발생하거나 발생할 우려가 있는 경우와 정전, 서비스 이용 폭주 등으로 정상적인 서비스가 불가능한 경우 등 기타 불가항력적인 사유가 있는 경우에는 서비스 이용의 전부 또는 일부를 제한하거나 중지할 수 있습니다.
3. 제1항에 의한 서비스 중단의 경우에는 회사는 회원에게 제11조의 방법으로 통지를 합니다. 단, 회사가 통제할 수 없는 사유로 인한 서비스 중단으로 사전 통지가 불가능한 경우에는 사후적으로 통지합니다.
4. 회사는 제1항의 사유로 서비스의 제공이 일시적으로 중단됨으로 인하여 이용자 또는 제3자가 입은 손해에 대하여 배상합니다. 단, 회사의 고의 또는 과실이 없음을 입증하는 경우에는 그러하지 아니합니다.
제 11 조 (회원에 대한 통지)
1. 회사가 회원에 대한 통지를 하는 경우에는 회원이 서비스 이용 신청 시 사이트 내 공지사항 또는 회원가입 시 제출한 이메일 주소로 할 수 있습니다.
2. 회사는 불특정 다수 회원에 대한 통지의 경우 7일 이상 사이트 내 공지사항에 게시함으로써 개별 통지에 갈음할 수 있습니다.
제 12 조 (회원탈퇴 및 자격상실)
1. 회원이 이용계약을 해지하고자 하는 때에는 회원 본인이 사커하우 내의 메뉴 또는 전화 등의 방법을 이용하여 가입해지를 신청할 수 있으며, 회사는 즉시 회원 탈퇴 처리를 합니다.
2. 회원 탈퇴가 이루어짐과 동시에 서비스 이용과 관련된 모든 정보는 삭제됩니다. 이로 인해 발생하는 불이익에 대한 책임은 회원 본인에게 있습니다.
3. 회원이 다음 각 호의 사유에 해당하는 경우, 회사는 회사는 1차 위반 시 경고, 2차 위반 시 회원의 회원자격을 적절한 방법으로 일부 기능 제한 및 영구 정지시킬 수 있습니다.(단, 위반의 심각성과 빈도, 재발 가능성, 고의성 들에 따라 경고 처리 없이 영구 정지시킬 수 있습니다.)
   1) 가입 신청 시에 허위 내용을 등록한 경우
   2) 다른 사람의 &서비스&이용을 방해하거나 그 정보를 도용하는 등 전자거래질서를 위협하는 경우
   3) 서비스를 이용하여 법령과 본 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우
   4) 영리목적으로 개인 휴대폰 번호 혹은 개인 홈페이지, SNS 주소 등을 노출하여 우회거래를 유도한 경우
   5) 커뮤니티에서 불건전 게시물을 상습적으로 게시하거나, 유사 게시물을 지속적으로 게시한 경우
   6) 같은 사용자가 다른 계정으로 이중 등록을 한 경우
   7) 사커하우에서 이용약관 또는 법률 위반 등의 사유로 이전에 회원자격이 상실 또는 이용계약이 해지되었던 경우
  8) 회사로부터 회원자격정지 조치를 받은 회원이 이용정지 중에 이용계약을 임의 해지하고 재이용 신청을 하는 경우
4. 회사가 회원에게 경고,일부기능 제한을 통지한 후 5영업일 이내에 그 사유가 정지 또는 시정되지 아니하는 경우에는 회원자격을 상실시킬 수 있습니다.
5. 회사가 회원자격을 상실시키는 경우 회원에게 이를 통지하고, 회원등록 말소 전에 5영업일 간 소명할 기회를 부여합니다.
6. 회원은 회사의 이용제한 및 회원자격 상실 조치에 대하여 이의신청을 할 수 있습니다. 회원의 이의신청이 정당한 경우 회사는 즉시 회원이 서비스를 이용할 수 있도록 필요한 조치를 취합니다.
제 4 장 지급 수단
제 13 조 (앱내 카드 결제)
1. 일반 회원은 사커하우에서  축구관련 전문지식에 대해 질문을 할 수 있고, 금액을 설정하여,  신속하고 성의 있는 답변을 채택해 결제할 수 있습니다
2. 코치 회원은  일반회원이 요청한 질문에 신속하고 노하우 있는 답변으로 회원으로부터 지적 재산에 대한 금액을 받을 수 있습니다.
3. 코치 회원은 축구를 전문적으로 한 사람으로 용병으로 등록되어 여러 축구 경기에 용역을 제공할 수 있으며, 이를 이용하는 회원은 앱내에서 결제를 하고, 경기후에 용병에 대한 평가를 할 수 있습니다.
4. 회사는 회원이 환불을 요청한 날로부터 3영업일 이내에 회원이 결제한 수단과 동일한 수단으로 대금을 환불하여야 합니다. 다만, PG사를 통한 실질적인 결제 취소는 신용카드 및 휴대폰결제의 경우에는 약 3 내지 5 영업일 정도가 소요될 수 있습니다.,
5. 제 4항에도 불구하고 다음 각호와 같이 부득이한 경우 회사는 3영업일 내에 회원의 계좌로 금원을 송금하는 방식으로 환불을 진행합니다.
  1) 카드결제 시점으로부터 1년이 경과한 경우
  2) 휴대폰 소액결제 당월 전액 환불이 아닌 경우
  3) 기타 결제수단으로 환불이 불가한 경우
회사는 위 대금을 환급함에 있어 회원이 신용카드 또는 전자화폐 등의 결제수단으로 대금을 지급한 때에는 지체 없이 당해 결제수단을 제공한 사업자로 하여금 대금 청구를 정지 또는 취소하도록 요청합니다.
6. 코치 또는 지점은 는 회사에서 운영하는 수수료 정책에 동의함으로 사커하우에서 활동을 시작한다.
   회사에 납부해야할 수수료는 2024년 현재 사커하우 20%이며,  카드사의 수수료와 세금은 별도로 한다.
7. 코치 또는 지점은 개인사업자 혹은 프리랜서로서 개인이 세금 신고를 따로 하여야하며, 이를 위반시에 회사는 이와 관련한 법적책임을 지지 아니한다.
8. 만약 코치가 사업자가 없을 경우에 코치의 요청에 의해 회사에서 원천징수 3.3%에 대한 세금을 프리랜서로서 세무서에 대신 신고해 줄 수 있다.


제 5 장 서비스 이용 계약의 해제, 해지
제 14 조 (회사의 서비스 이용 계약해제, 해지 및 이용제한)
1. 회사는 거래의 안정성을 위해 이 약관에서 정한 바에 따라 회원 자격을 정지하거나, 서비스 이용 제한 등의 조치를 취할 수 있습니다.
2. 회사는 다른 이용자의 약관 위반 행위에 가공하거나 공모한 것이 객관적으로 인정되는 이용자 또는 약관 위반 행위를 돕거나 그로 인해 부당한 이득을 취한 것이 객관적으로 인정되는 이용자에 대해서도 해당 약관 위반 행위에 대한 제재를 적용할 수 있습니다.
3. 회사가 회원자격을 정지하거나 이용제한 등 기타 필요한 조치를 취할 경우 이 약관에 특별한 규정이 없는 한 사전에 회원에게 유선 또는 메일 등 알림을 통해 통보하며 회원이 연락 두절 되거나 긴급을 요하는 부득이한 경우 선조치 후통보 할 수 있습니다.
4. 계정 공유 중 제 3자가 이용자 본인의 계정을 이용하여 약관 위반 행위가 발생한다고 하더라도 이용자 본인 및 해당 계정에 제재가 적용될 수 있습니다.
5. 다음 각 호의 행위는 약관 위반 행위에 해당하며 1차 위반 시 경고, 2차 위반 시 회원 자격 정지 또는 서비스 이용 제한 등의 제재 조치가 취해질 수 있습니다. (단, 위반의 심각성과 빈도, 재발 가능성, 고의성 등에 따라 경고 처리 없이 영구 정지시킬 수 있습니다.)
  1) 상업적 광고 행위  “상업적 광고 행위” 란 채팅, 프로필, 게시글 등을 이용하여 이루어지는 아래 각 호의 행위를 의미합니다. - 음란사이트 광고 행위 - 피라미드, 금융 서비스를 광고하는 행위 - 위법, 위조 등이 가능한 서비스를 광고하는 행위
  2) 사행 행위   “사행행위” 란 아래 각 호의 행위를 의미합니다.   - 불법 도박 사이트 서비스를 광고하는 행위   - 사회통념상 납득되지 않는 서비스를 광고하는 행위
  3) 버그 및 제한사항 악용   “버그 및 제한사항 악용”  이란 아래 각 호의 행위를 의미합니다.   - 고의로 서비스 오류를 이용하여 이득을 얻거나, 서비스 내 경제 시스템에 영향        을 주는 행위   - 고의로 서비스 오류를 이용하여 다른 이용자에게 피해를 주는 행위   - 고의로 서비스 오류를 이용하여 시스템에 영향을 주는 행위
  4) 어뷰징   “어뷰징” 이란 아래 각 호의 행위를 의미합니다.
   - 고의로 리뷰 및 고용 수 등을 조작하는 행위
   - 코치의 서비스 정책 및 시스템 상 허용되지 않는 방법으로 리뷰 및 고용수를 조작하는 행위
    <예시>
    - 타플랫폼 또는 외부유입고객을 통해 리뷰 또는 고용을 조작하는 행위
    - 다수의 사커하우 계정을 이용하여 리뷰 또는 고용을 조작하는 행위
    - 동일인이 수 개 사커하우 계정을 이용하여 리뷰 또는 고용을 조작하는 행위
    - 불법 언더 마케팅 서비스로 리뷰 또는 고용을 조작하는 행위
    - 회사가 제공하는 서비스 이용방법에 의하지 아니하고 비정상적인 방법으로 리뷰 및 고용수를 조작하는 행위
   - 일반적으로 서비스에 통용되지 아니하는 방법으로 재화를 늘리는 행위
   - 비정상적으로 시스템 설계상 제한을 회피하여 이익을 취하는 행위 (예시. 커뮤니티나 프로필 내 개인 휴대폰 번호, SNS/홈페이지 주소를 게시하여 우회 거래를 유도하는 행위 등)
   - 시스템상 허용되지 않는 방법으로 다른 이용자의 평판 이익을 늘리는 행위
  5) 불건전 언어 사용
    “불건전 언어 사용” 이란 아래 각 호의 행위를 의미합니다.- 욕설, 비/속어 등을 사용하는 행위- 음란한 단어나 노골적인 성 묘사 등을 통해 성적 수치심을 느끼게 하는 표    현이나 행동을 하는 행위- 다른 이용자에게 불쾌감이나 성적 수치심을 줄 수 있는 명칭을 사용하는 행     위- 현실에 대한 위협이나 상대방에게 공포심을 느끼게 하는 표현이나 행동을      하는 행위- 기타 약관에서 금지하는 표현이나 통신을 하여 상대방에게 불쾌감이나 혐오     감을 주는 행위- 제3자의 명예, 초상권, 개인정보를 포함한 제반 권리를 침해, 훼손할 목적의    내용이 포함된 대화 등 이에 준하는 행위
  6) 불건전 이름(닉네임) 사용“ 불건전 이름 사용” 이란 온라인 문화를 저해하거나 관계 법령 및 사회질서와 미풍 양속을 저해하는 내용과 욕설 또는 음란한 내용으로 만든 이름, 비즈니스 네임 등을 포함하여 명명된 아래 각 호의 행위를 의미합니다.- 사커하우 직원 및 관리자 또는 제3자를 사칭하는 행위- 욕설, 비/속어 등을 사용하는 행위- 다른 이용자에게 불쾌감이나 성적 수치심을 줄 수 있는 명칭을 사용하는 행위- 기타 약관에서 금지하는 명칭을 사용하는 행위
     관련 계정의 닉네임 등은 임의로 변경될 수 있습니다
   7) 명의도용“명의도용” 이란 아래 각 호의 행위를 의미합니다.- 타인의 개인정보를 이용하여 계정을 생성하는 행위
   8) 결제도용“결제도용” 이란 아래 각 호의 행위를 의미합니다.- 타인의 결제수단을 무단으로 이용하여 서비스 이용요금 등을 결제하는 행위
   9) 불건전 게시물 게시“불건전 게시물 게시”란 아래 각 호의 행위를 의미합니다.- 회사 또는 제3자의 권리(저작권, 특허 등)를 침해하는 게시물- 본인/타인의 개인정보(신상정보, 위치, 연락처, 이메일 등)이 포함된 게시물- 다른 사람에게 성적 수치심을 주거나 혐오감, 불쾌감을 유발하는 게시물- 다른 사람을 비방하거나 음해하는 목적의 게시물(인신공격, 루머 포함)- 영리 목적의 광고 게시물(경품, 상품광고, 사이트 홍보 등)- 악성코드가 포함되어 있거나 시스템 장애를 유도하는 게시물- 특정 사상/종교적 색채가 짙은 게시물- 특정 개인 및 회사에 대한 허위 사실을 악의적으로 유포하는 게시물- 인종, 성, 특정 지역을 비하하거나 차별하는 게시물- 폭력, 비행, 사행심을 조장하는 게시물- 약관 위반 행위와 관련된 게시물- 기타 약관, 관련 법령에서 금지하는 게시물- 짧은 시간에 많은 양의 게시물을 등록하거나 동일한 내용을 반복 게시하여 운영을 방해하는 행위
   10) 부정 결제 행위“부정 결제 행위”란 사커하우 이용 시 아래 각 호와 같이 시장 질서를 교란하는 불법행위를 의미합니다.- 물품 및 용역의 실제 거래 없이 자금을 결제하는 허위 거래 행위- 사커하우의 결제수단만을 이용하기 위한 결제 행위- 결제 수단의 현금화 행위- 부정한 목적의 무상 혜택 사용 행위 (쿠폰 등)- 결제수단의 명의를 타인에게 빌려주는 행위- 거래되는 물품 또는 용역의 내용을 정확히 제시하지 않은 거래에 대한 결제
회원은 회사의 해제․해지 및 이용제한에 대하여 이의신청을 할 수 있습니다. 회원의 이의신청이 정당한 경우 회사는 즉시 회원이 서비스를 이용할 수 있도록 필요한 조치를 취합니다.

제 15 조 (회사의 계약해제․해지의 효과)
 1. 회사가 제12조 또는 제20조에 따라 서비스 이용계약을 해제 또는 해지한 경우 회원의 고의 또는 과실로 인하여 회사에 손해가 발생한 경우 회사는 회원에게 손해배상을 청구할 수 있습니다. 다만, 회원이 고의 또는 과실 없음을 증명한 경우에는 그러하지 않습니다.
제 6 장 개인 정보의 처리
제 16 조 (회원의 개인정보 보호)
 1. 회사는 회원의 개인정보를 보호하기 위하여 정보통신망법 및 개인정보 보호법 등 관계 법령에서 정하는 바를 준수하며 이용자의 개인 식별이 가능한 개인정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.
 2. 회사의 개인정보 보호는 사커하우 개인정보처리방침에 따릅니다.
제 7 장 당사자의 의무
제 17 조 (회사의 의무)
1. 회사는 회원이 희망한 서비스 제공 개시 일에 특별한 사정이 없는 한 서비스를 이용할 수 있도록 하여야 합니다.
2. 회사는 계속적이고 안정적인 서비스의 제공을 위하여 설비에 장애가 생기거나 기계의 결함이 있는 때에는 부득이한 사유가 없는 한 지체 없이 이를 수리 또는 복구합니다.
3. 회사는 개인정보 보호를 위해 보안시스템을 구축하며 개인정보 보호정책을 공시하고 준수합니다.
4. 회사는 고객센터에 회원으로부터 제기되는 의견이나 불만에 대하여 3영업일 이내에 진행 경과를 회원에게 알리고 10영업일 이내에 조사 결과 또는 처리 방안을 회원에게 알립니다.
제 18 조 (회원의 의무)
1. 회원은 다음 각 호의 행위를 하여서는 안 됩니다.
  1) 회원가입신청 또는 변경 시 허위내용을 등록하는 행위
  2) 사커하우에 게시된 정보를 허위로 변경하는 행위
  3) 회사 기타 제3자의 인격권 또는 지적재산권을 침해하거나 업무를 방해하는 행위
  4) 다른 회원의 ID를 도용하는 행위
  5) 관련 법령에 의하여 그 전송 또는 게시가 금지되는 정보(컴퓨터 프로그램 등)의 전송 또는 게시하는 행위
  6) 회사의 직원이나 관리자를 가장하거나 사칭하여 또는 타인의 명의를 오용하여 글을 게시하거나 메일을 발송하는 행위
  7) 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비의 정상적인 가동을 방해, 파괴할 목적으로 고안된 소프트웨어 바이러스, 기타의 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시하거나 전자우편으로 발송하는 행위
  8) 스토킹(stalking) 등 다른 회원을 괴롭히는 행위
  9) 다른 회원에 대한 개인정보를 그 동의 없이 수집, 저장, 공개하는 행위
  10) 회사가 제공하는 서비스에 정한 약관 기타 서비스 이용에 관한 규정을 위반하는 행위
  11) 외설 또는 폭력적인 메시지ㆍ화상ㆍ음성 기타 공서양속에 반하는 정보를 공개 또는 게시하는 행위
  12) 사실관계를 왜곡하는 정보제공 등 기타 회사가 부적절하다고 판단하는 행위
  13) 기타 관계 법령이나 회사에서 정한 규정에 위배되는 행위
 2. 회원이 개인의 정보를 허위 또는 잘못 기재하여 생기는 불이익에 대한 책임은 회원 본인에게 있으며, 이에 대해 회사는 아무런 책임이 없습니다.
 3. 회사가 사이트 운영상 부적절하다고 판단한 정보가 게시된 경우, 회사는 게시를 행한 자의 승낙 없이 게재된 당해 정보를 삭제할 수 있습니다. 단, 회사는 이러한 정보의 삭제 등을 할 의무를 지지 않습니다.
 4. 회사는 회원이 본 약관 또는 당사 정책에 위반되는 내용의 메시지를 프로필 영역에 작성하거나 타 회원에게 해당 메시지 내용을 발송하는 경우 별도의 통지 없이 작성 또는 발송된 내용을 임의로 수정 또는 삭제할 수 있습니다.
 5. 제1항에 해당하는 행위를 한 회원이 있을 경우 회사는 본 약관 제12조, 제21조에서 정한 바에 따라 회원의 회원자격을 적절한 방법으로 제한 및 정지, 상실시킬 수 있으며, 특히 아래 각 호에 해당하는 행위를 할 경우에는 각각에 대응되는 조치를 취할 수 있습니다. 다만, 회사가 취할 수 있는 조치는 아래 각 호에 한정되지 아니하며, 회사가 조치를 취할 수 있는 회원의 불법적인 행위 역시 아래 각 호의 경우에 한정되지 아니합니다.
   1) 타 회원들에 대한 무단 마케팅(요청서 및 견적에 제공 용역에 대한 내용 외 본인의 영리적 목적을 위한 내용을 무단으로 작성하는 것을 의미하며 광고 등을 포함): 모든 기능 사용 정지
    2) 타 회원들에 대한 부적절한 대화 시도 및 메시지 발송 등(욕설, 성희롱, 기타 부적절한 표현을 포함함): 모든 기능 사용 정지(영구 제재)
    3) 타 회원들에게 허위사실을 유포하거나 표시광고를 위반하는 경우(견적에 회사에 상당한 수수료를 지불하고 있어, 절대 채팅으로 답변하지 말라는 내용을 기재하거나, 명함에 사커하우 로고를 무단으로 표시하고 자신을 사커하우협력사로 소개하는 등을 포함함): 모든 기능 사용 정지(영구 제재)
    4) 코치 회원의 의무 및 서비스 정책 위반(프로필에 계속하여 휴대폰 번호 등 개인정보를 노출, 요청서 또는 견적에 본인 연락처를 작성하여 직접 연락을 유도하는 등의 경우를 포함함): 모든 기능 사용 정지
    5) 타 회원들에 대해 구인, 구직, 영업, 영입 등을 제안하는 행위 (특정 서비스 제외) : 모든 기능 사용 정지 (영구 제재)
 6. 회원은 그 귀책사유로 인하여 회사나 다른 회원이 입은 손해를 귀책의 정도에 따라 배상할 책임이 있습니다.
 7. 회원은 서비스의 이용과 관련하여 관계법령, 약관, 세부이용지침, 서비스 이용안내 및 회사가 통지한 공지사항 등을 준수하여야 하며, 이를 수시로 확인하여야 합니다.
제 19 조 (회원의 의무)
 1. 회원은 제공받기 원하는 지역에 나의 위치가 표시대고 근처의 다른 회원이나 코치들이 나의 기재된 정보를 보고, 커뮤니티를 할 수 있는 것에 대하여 동의합니다.
 2. 회원은 축구 경기후 서로에게 받는 평가에 대해 동의하며, 이를 허위로 작성할수 없으며, 회원 상호간의 예의를 지켜서 행동하는 것에 동의합니다.
 3. 회원은 허위나 과장된 내용으로 회원이나 코치에게 연락하거나 또는 레슨을 제공받고자 하는 의사가 없음에도 요청서를 작성할 수 없으며, 허위 및 과장된 내용으로 레슨이나 용병을 요청함에 따라 용역을 제공받지 못하거나 법적인 문제가 발생할 경우 이에 대한 책임은 고객에게 있습니다.
 4. 고객은 용역을 구매하기 전에 반드시 코치 회원과 용역의 상세 내용과 거래의 조건을 정확하게 확인해야 합니다. 구매하려는 용역의 내용과 거래의 조건을 확인하지 않고 구매하여 발생한 모든 손실과 손해는 고객 본인이 부담합니다.
제 20 조 (코치 회원의 서비스 관련 의무)
1. 코치 회원은 용역의 제공, 계약내용의 변경, 용역 대금 결제 및 환불 등 용역 제공과 관련한 일체의 업무를 처리하며, 이를 신의성실 하게 이행하여야 할 의무가 있습니다. 또한 용역 제공과 관련하여 발생하는 모든 책임과 의무를 부담합니다.
2. 코치 회원이 작성한 견적, 프로필 등에 허위 또는 과장, 도용, 사칭, 기재누락, 오기가 있어서는 아니되며 이를 준수하지 아니하여 발생하는 모든 법적문제에 대하여는 코치 회원이 모든 책임을 부담합니다. 코치 회원은 해당 레슨의 견적 및 제공 용역에 대한 진실성과 적법성에 대해 보증합니다.
3. 코치 회원은 작성한 견적, 용역의 내용, 용역 제공 시기 등 내용의 변경 사항이 있을 경우 이를 바로 갱신하여야 할 의무를 집니다.
4. 코치 회원은 관련법령 등을 위반하는 불법적인 용역을 제공하지 않는 다른 점에 대해 보증하며 불법적이거나 본 이용약관을 위반하는 내용으로 견적및 허위 내용을 작성하여 고객에게 송부할 수 없습니다.
5. 코치 회원은 견적을 수령한 회원과의 사커하우 서비스에서 제공하는 메시지 기능이나 전화 등 별도의 연결수단을 통하여 세부사항을 조정할 수 있습니다. 회사는 견적 발송 이후 고수 회원과 고객 간에 발생한 일체의 문제에 대하여 어떠한 책임도 지지 않습니다.
제 21 조 (회원의 ID 및 비밀번호에 대한 의무)
 1. 원칙적으로 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.
 2. 회원은 자신의 ID 및 비밀번호를 제 3자에게 이용하게 해서는 안 되며, 그로 인한 모든 책임은 회원에게 있습니다.
 3. 회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 회사에 통보하고 회사의 안내가 있는 경우 그에 따라야 합니다. 만약 회원이 위 사실을 인지하고도 회사에 대한 통보를 지체함으로써 발생한 손해에 대해서 회사는 배상할 의무가 없습니다.
제 22 조 (게시물 또는 내용물의 삭제)
 1. 회사는 회원이 게시하거나 등록한 내용이 제20조 제4항 또는 제34조 제1항에 위반되거나 회사 소정의 게시기간을 초과하는 경우 사전 통지나 동의 없이 이를 삭제할 수 있습니다. 그러나 회사가 이러한 정보의 삭제 등을 할 의무를 지는 것은 아닙니다.
 2. 회사는 회원이 이용계약을 해지하고 사이트를 탈퇴하거나 적법한 사유로 해지된 경우 해당 회원이 게시하였던 게시물을 삭제할 수 있습니다.
 3. 회원이 작성한 게시물에 대한 모든 권리 및 책임은 이를 게시한 회원에게 있으며, 회사는 회원이 게시하거나 등록한 게시물이 다음 각 호에 해당한다고 판단되는 경우에 사전통지 없이 임시조치(해당 게시물에 대한 접근을 일시적으로 차단하는 조치를 의미합니다)를 할 수 있고, 임시조치 15일 이내에 이의제기가 없을 경우에는 회원에게 통지 후 삭제합니다. 이에 대하여 회사는 고의 또는 과실이 없는 한 어떠한 책임도 지지 않습니다.
 4. 다른 회원 또는 제3자를 비방하거나 명예를 손상시키는 내용인 경우
 5. 회사의 저작권, 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우
 6. 개인정보가 포함되었을 경우
 7. 욕설, 비속어, 음란한 내용이 포함된 경우
 8. 실제 거래/고용등이 되지 아니한 코치에게 작성된 경우
 9. 코치가 제공한 서비스와 관련 없는내용이나 사진이 포함된 경우
 10. 의미없는 모음, 자음, 특수문자 등의 나열에 해당하는 경우
 11. 취소(환불/부분환불 포함)된 거래에 대한 리뷰. (단, 고객이 거래 취소 및 리뷰가 삭제될 수 있음에 동의한 경우에만 해당)
 12. 악의적인 목적, 의미없는 내용을 게시하는 등 목적에 어긋나는 경우
 13. 동일한 내용을 도배성으로 중복게시하는 경우
 14. 기타 관계법령에 위반된다고 판단되는 경우
제 23 조 (회원게시물의 관리)
1. 회원은 게시물을 작성할 때 타인의 저작권 등 지식재산권을 포함하여 여타 권리를 침해하지 않아야 하고, 회사는 그에 대한 어떠한 책임도 부담하지 않습니다. 만일 회원이 타인의 권리 등을 침해하였음을 이유로 타인이 회사를 상대로 이의신청, 손해배상청구, 삭제요청 등을 제기한 경우 회사는 그에 필요한 조치를 취할 수 있으며, 그에 따른 모든 비용이나 손해배상책임은 회원이 부담합니다. 단, 회사의 고의 또는 과실이 있는 경우에는 법률이 따른 책임을 부담합니다.
2. “회원”의 “게시물”이 정보통신망법 및 저작권법 등 법령에 위반되는 내용을 포함하거나 타인의 권리를 침해하는 내용을 포함하는 경우, 권리를 침해받은 자(이하'권리자')는 침해사실을 회사에 소명하여 해당 “게시물”의 게시중단 및 삭제 등을 요청할 수 있으며, 회사는 지체없이 게시중단 또는 삭제 등의 필요한 조치를 하고 권리자 및 해당 게시물 게시자에게 알려야 합니다. 단, 권리의 침해 여부를 판단하기 어렵거나 이해당사자 간에 다툼이 예상되는 경우에는 15일 동안 임시조치를 합니다.
 3. 회사는 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우에는 관련법에 따라 해당 “게시물”에 대해 15일 동안 임시조치 또는 삭제 조치를 취할 수 있습니다.
 4. 본 조에 따른 세부 절차는 정보통신망법 및 저작권법이 규정한 범위 내에서 회사가 정한 게시중단요청서비스 에 따릅니다.
    < 게시중단 요청 :  SH_support@obyungear.com >
제 24조 (저작권의 귀속 및 권리, 의무)
 1. 회사가 작성한 저작물에 대한 저작권 기타 지식재산권은 회사에 귀속합니다.
 2. 회원은 회사의 서비스를 이용함으로써 얻은 정보를 회사의 사전승낙 없이 복제, 전송, 출판, 배포, 방송 기타 방법에 의하여 영리목적으로 이용하거나 제3자에게 이용하게 하여서는 안 됩니다.
 3. 회원이 작성한 게시물에 대한 모든 권리 및 책임은 이를 게시한 회원에게 있습니다.
 4. 회사는 회원 또는 요청자가 사이트에 게시한 다음 각 호의 게시물을 회사의 서비스 제공과 관련한 마케팅 용도로 사용ㆍ복제ㆍ수정ㆍ출판ㆍ배포 할 수 있습니다. 단, 회사는 게시물 이용시 코치 또는 요청자의 개인정보가 포함되지 않는 범위에서 해당 정보를 처리하고, 최대한 작성자의 권리를 보호할 수 있도록 노력할 것입니다.
   1) 코치의 프로필 정보
   2) 회원 및 코치가 작성한 후기(이에 포함된 글 및 사진)
   3) 요청서 및 견적의 내용
   4) 회사와  회원 또는 코치 사이의 연락 내용
   5) 기타 회원 및 코치가 서비스 이용과정에서 작성·게시한 콘텐츠
제 25 조 (광고주 및 연결 사이트와의 관계)
 1. 회사의 공식 사이트 이외의 웹사이트 및 이메일에서 링크된 사이트에서는 회사의 개인정보 보호정책 및 본 약관이 적용되지 않습니다.
 2. 회사는 사커하우 사이트 또는 e-mail 상에 게재되어 있거나 본 서비스를 통한 광고주의 판촉활동에 회원이 참여하거나 교신 또는 거래를 함으로써 발생하는 손실과 손해에 대해 책임을 지지 않습니다.
제 8 장 기타
제 26 조 (양도의 금지)
 1. 회원은 서비스 이용 권리를 타인에게 대여, 양도 또는 증여 등을 할 수 없으며, 또한 질권의 목적으로도 사용할 수 없습니다.

제 27 조 (면책)
 1. 회사는 회사의 고의 또는 과실이 없는 경우 다음 각 호의 경우에 대하여 책임이 없습니다.
  1) 회사는 천재지변 또는 이에 준하는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 구매자에게 발생한 손해에 대하여 서비스 제공에 관한 책임이 면제됩니다.
  2) 회사는 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여 책임을 지지 않습니다.
  3) 회사는 회원이 서비스의 이용을 통해 예상했던 금전적인 수익을 얻지 못하게 되거나, 서비스를 통하여 얻은 자료로 인해 손해를 보게 되더라도 이에 관하여 책임을 지지 않습니다.
  4) 회사는 회원이 서비스에 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는, 회사가 해당 정보의 허위성을 명백히 인지하였다는 특별한 사정이 없는 한, 책임을 지지 않습니다. 회사가 이 약관과 관련 법령에 따른 조치를 취한 경우에도 같습니다.
  5) 회사는 서비스 이용과 관련하여 회사의 고의, 과실에 의하지 아니한 손해에 대하여 책임을 지지 않습니다.
  6) 회사는 기간통신 사업자가 전기통신 서비스를 중지하거나 정상적으로 제공하지 아니하여 손해가 발생한 경우 책임이 면제됩니다.
  7) 회사는 회원들에게 요청서와 견적을 전달하거나 광고플랫폼 서비스를 제공하고 이에 대한 부수적인 서비스를 제공할 뿐이므로 회원 상호 간 서비스를 매개로 하여 거래를 한 경우 이용자 각자의 의무이행에 대한 책임은 각 이용자에게 있으며 회사는 이에 대한 책임이 없습니다.
  8) 회사는 회원들에게 요청서와 견적을 전달하거나 광고플랫폼  서비스를 제공하고 이에 대한 부수적인 서비스를 제공할 뿐이므로 코치와 회원 간 거래와 관련하여 발생한 의무의 불완전 이행, 이행 지체 등 용역 이행 미비, 사후처리, 대금 정산, 완성품의 하자, 청약철회, 물품의 반품 등 어떠한 법적 분쟁 및 사후처리에 대해서도 개입하거나 책임지지 않습니다.
  9) 회사는 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.
  10) 회사는 회원 간에 분쟁이 발생하였을 경우 회원 간 법적 문제에 대하여 책임을 지지 않습니다.
제 28 조 (손해배상)
 1. 당사자 일방이 본 계약상 의무를 위반함으로 인하여 상대방에게 손해가 발생한 경우, 귀책사유 있는 당사자는 상대방이 입은 손해를 배상합니다.

제 29 조 (비밀유지)
 1. 당사자는 서비스를 이용하는 과정에서 알게 된 상대방의 정보 또는 이용자의 정보를 제3자에게 누설, 공개하지 아니합니다.
 2. 본 조는 이용계약이 해지되거나 서비스 제공이 중단된 이후에도 유효합니다.
제 30 조 (고객센터)
 1. 회사는 이용자에게 생긴 문제를 해결하기 위해 최선을 다하며 이를 위하여 이용자로부터 고객센터에 제출되는 불만사항 및 의견은 3영업일 이내에 진행 경과를 이용자에게 알리고 10영업일 이내에 조사 결과 또는 처리방안을 이용자에게 알립니다. 다만, 신속한 처리가 곤란한경우에는 이용자에게 그 사유와 처리일정을 즉시 통보합니다.
 2. 회사와 이용자 간 분쟁이 발생할 경우 양자 간 합의에 의하여 처리하는 것을 원칙으로 하며 회사는 이용자 간 발생한 법적 문제에 대하여 고의 또는 과실이 없는 한 책임이 없습니다. 그러나 회사는 고객센터를 통하여 피해 사항을 적극적으로 청취하여 이용자들 간 발생한 문제가 해결하는 데에 도움이 될 수 있도록 최선을 다합니다.
 3. 회원은 사이트 초기화면의 고객센터를 통해 불만사항 및 의견을 제출할 수 있습니다.
제 31 조 (재판권 및 준거법)
 1. 회사와 이용자간 발생한 분쟁에 관한 소송의 관할은 민사소송법에 따라 정합니다.
 2. 회사와 이용자 간에 제기된 소송에는 대한민국법을 적용합니다.
부칙
제1조 (시행일) 이 약관은 2024년 7월 15일부터 시행합니다.`
            }
        }
    }
</script>

<style scoped>
    .backdrop{
        position:fixed;
        left:0px; top:0px; width:100%; height:100%;
        background-color: rgba(0,0,0,0.4);
        opacity: 1.0;
        z-index:100;
    }

    .blur-enter-active, .blur-leave-active {
        transition: opacity .5s;
    }

    .blur-enter, .blur-leave-to {
        opacity:0.0
    }

    .menu_option_wrap{
        top:0px;position:fixed;left:0px; width:100%; height:100%; z-index:100; display:grid; place-items: center;
    }
    .each_menu + .each_menu{border-top:1px solid #EBEBEB;}
    .bottom-enter-active, .bottom-leave-active {
        transition: top .5s;
    }

    .bottom-enter, .bottom-leave-to {
        top: 100%;
    }

    .btn{color:#D9D9D9; font-size:14px; font-weight:500; display:grid; place-items: center; border-radius:12px; height:48px; background-color: #EDEDED;}
    .btn.active{color:white; background-color: black;}
</style>